var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delay, getRandomNumber } from 'ziphy-web-shared/basic/helpers';
export function getFakeMock(prepared) {
    return __awaiter(this, void 0, void 0, function* () {
        yield delay(getRandomNumber(30, 200));
        return {
            id: getRandomNumber(9000, 10000),
            meta: {},
            error: null,
            warnings: [],
            prepared,
            // isFromCache: true,
        };
    });
}
export const marcosMock = [];
export const selectsMock = [
    {
        id: 'procedure_status',
        version: 1,
        created: '2025-03-12T17:45:03Z',
        modified: null,
        name: 'Procedure Status',
        title: 'PROCEDURE STATUS',
        values: [
        // { code: '', title: '' },
        ],
    },
    {
        id: 'immunization_status',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Immunization status',
        title: 'Immunization status',
        freeText: null,
        preferred: null,
        values: [
            {
                code: 'completed',
                title: 'Completed',
                description: null,
            },
            {
                code: 'entered-in-error',
                title: 'Entered in error',
                description: null,
            },
            {
                code: 'not-done',
                title: 'Not Done',
                description: null,
            },
        ],
    },
    {
        id: 'alcohol_consumption_code',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Alcohol consumption',
        title: 'Alcohol consumption',
        freeText: {
            placeholder: 'MM/DD/YYYY',
            title: 'Former',
            type: 'date',
        },
        preferred: null,
        values: [
            {
                code: 'unknown',
                title: 'Unknown',
                description: null,
            },
            {
                code: 'never',
                title: 'Never',
                description: null,
            },
            {
                code: 'yes_sometimes',
                title: 'Yes, Sometimes',
                description: null,
            },
            {
                code: '1_2_drinks_a_week',
                title: '1-2 Drinks a Week',
                description: null,
            },
            {
                code: '3_4_drinks_a_week',
                title: '3-4 Drinks a Week',
                description: null,
            },
            {
                code: '5_drinks_a_week',
                title: '5+ Drinks a Week',
                description: null,
            },
        ],
    },
    {
        id: 'hobbies_code',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Hobbies or other recreational activities',
        title: 'Hobbies or other recreational activities',
        preferred: null,
        values: [
            {
                code: 'unknown',
                title: 'Unknown',
                description: null,
            },
            {
                code: 'no_hobbies',
                title: 'No Hobbies',
                description: null,
            },
            {
                code: '1_2_times_per_week',
                title: '1-2 Times per Week',
                description: null,
            },
            {
                code: '3_5_times_per_week',
                title: '3-5 Times per Week',
                description: null,
            },
            {
                code: '5_or_more_times_per_week',
                title: '5 or More Times per Week',
                description: null,
            },
        ],
    },
    {
        id: 'hours_of_sleep_code',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Hours of sleep',
        title: 'Hours of sleep',
        preferred: null,
        values: [
            {
                code: 'unknown',
                title: 'Unknown',
                description: null,
            },
            {
                code: 'less_than_4_hours_per_night',
                title: 'Less Than 4 Hours per Night',
                description: null,
            },
            {
                code: '4_5_hours_per_night',
                title: '4-5 Hours per Night',
                description: null,
            },
            {
                code: '6_8_hours_per_night',
                title: '6-8 Hours per Night',
                description: null,
            },
            {
                code: '9_or_more_hours_per_night',
                title: '9 or more hours per night',
                description: null,
            },
        ],
    },
    {
        id: 'sexual_behavior_code',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Sexual behavior',
        title: 'Sexual behavior',
        preferred: null,
        values: [
            {
                code: 'unknown',
                title: 'Unknown',
                description: null,
            },
            {
                code: 'abstinent',
                title: 'Abstinent',
                description: null,
            },
            {
                code: 'sexually_active',
                title: 'Sexually Active',
                description: null,
            },
        ],
    },
    {
        id: 'substance_use_code',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Substance Use',
        title: 'Substance Use',
        freeText: {
            placeholder: 'MM/DD/YYYY',
            title: 'Former',
            type: 'date',
        },
        preferred: null,
        values: [
            {
                code: 'unknown',
                title: 'Unknown',
                description: null,
            },
            {
                code: 'never',
                title: 'Never',
                description: null,
            },
            {
                code: 'yes_sometimes',
                title: 'Yes, Sometimes',
                description: null,
            },
            {
                code: 'yes_daily',
                title: 'Yes, Daily',
                description: null,
            },
        ],
    },
    {
        id: 'tobacco_user_code',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Tobacco user',
        title: 'Tobacco user',
        freeText: {
            placeholder: 'MM/DD/YYYY',
            title: 'Former',
            type: 'date',
        },
        preferred: null,
        values: [
            {
                code: 'unknown',
                title: 'Unknown',
                description: null,
            },
            {
                code: 'never',
                title: 'Never',
                description: null,
            },
            {
                code: 'yes_sometimes',
                title: 'Yes, Sometimes',
                description: null,
            },
            {
                code: '1_2_cigarettes_a_day',
                title: '1-2 Cigarettes a Day',
                description: null,
            },
            {
                code: '3_5_cigarettes_a_day',
                title: '3-5 Cigarettes a Day',
                description: null,
            },
            {
                code: '6_10_cigarettes_a_day',
                title: '6-10 Cigarettes a Day',
                description: null,
            },
            {
                code: '10_cigarettes_a_day',
                title: '10+ Cigarettes a Day',
                description: null,
            },
        ],
    },
    {
        id: 'travel_code',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Travel',
        title: 'Travel',
        preferred: null,
        values: [
            {
                code: 'unknown',
                title: 'Unknown',
                description: null,
            },
            {
                code: 'never',
                title: 'Never',
                description: null,
            },
            {
                code: 'yes_less_than_once_a_year',
                title: 'Yes, Less Than Once a Year',
                description: null,
            },
            {
                code: '1_2_times_a_year',
                title: '1-2 Times a Year',
                description: null,
            },
            {
                code: '3_4_times_a_year',
                title: '3-4 Times a Year',
                description: null,
            },
            {
                code: '5_6_times_a_year',
                title: '5-6 Times a Year',
                description: null,
            },
            {
                code: '7_or_more_times_a_year',
                title: '7 or More Times a Year',
                description: null,
            },
        ],
    },
    {
        id: 'living_status_code',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Living Status',
        title: 'Living Status',
        freeText: {
            type: 'text',
            title: 'Other',
        },
        preferred: null,
        values: [
            {
                code: 'independent',
                title: 'Independent at Home: Patient resides in their own home with full independence.',
                description: null,
            },
            {
                code: 'homebound',
                title: 'Homebound: Patient remains at home due to limited mobility or medical conditions.',
                description: null,
            },
            {
                code: 'assisted_living',
                title: 'Assisted Living: Patient lives in an assisted living facility with support available.',
                description: null,
            },
            {
                code: 'skilled_nursing_facility',
                title: 'Skilled Nursing Facility: Patient is residing in a nursing or long-term care facility.',
                description: null,
            },
            {
                code: 'transitional',
                title: 'Transitional Care/Group Home: Patient is in a transitional or group home setting for additional support.',
                description: null,
            },
        ],
    },
    {
        id: 'support_system_code',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Support System',
        title: 'Support System',
        freeText: {
            type: 'text',
            title: 'Other',
        },
        preferred: null,
        values: [
            {
                code: 'spouse_partner',
                title: 'Spouse/Partner: The patient is supported by a spouse or significant other.',
                description: null,
            },
            {
                code: 'adult_children_family_member',
                title: 'Adult Children/Family Member: Family members (children, siblings, etc.) provide support.',
                description: null,
            },
            {
                code: 'private_caregiver',
                title: 'Private Caregiver: A dedicated private caregiver assists with daily needs.',
                description: null,
            },
            {
                code: 'home_health_aide',
                title: 'Home Health Aide: Support is provided by a professional home health aide.',
                description: null,
            },
            {
                code: 'combination_of_family_and_professional_support',
                title: 'Combination of Family and Professional Support: Both family members and paid professionals (e.g., a caregiver or home health aide) are involved.',
                description: null,
            },
            {
                code: 'community_or_social_services',
                title: 'Community or Social Services: Assistance is provided through community programs or social services.',
                description: null,
            },
            {
                code: 'no_or_limited_support',
                title: 'No or Limited Support: Patient reports minimal or no available support.',
                description: null,
            },
        ],
    },
];
